export default __webpack_public_path__ + "static/media/smart-typing-logo.e74c2bcc.png";